exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".new-official-agency-description[data-v-25010d68]{box-sizing:border-box;min-height:360px;padding:28px 0 42px;background:#65abc5;color:#fff}.new-official-agency-description h2[data-v-25010d68]{margin:0 0 18px;font-size:25px;font-weight:900;line-height:29px}.new-official-agency-description p[data-v-25010d68]{margin:0 0 22px;font-size:18px;font-weight:400;line-height:25px}.new-official-agency-description p[data-v-25010d68]:last-child{margin-bottom:0}@media (max-width:900px){.new-official-agency-description[data-v-25010d68]{min-height:0;padding:30px 0 36px}.new-official-agency-description h2[data-v-25010d68],.new-official-agency-description p[data-v-25010d68]{font-size:18px;line-height:25px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25010d68","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/event/OfficialAgencyDescription.vue
// module id = 1089
// module chunks = 0